import { flow } from 'lodash';
import DragAndDrop from './DragAndDrop';
import withUserInput from '../../hocs/UserInput';
import withValidation from '../../hocs/Validation';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';

export default flow(withUserInput, withValidation)(
  DragDropContext(HTML5Backend)(DragAndDrop)
);



// WEBPACK FOOTER //
// ../core/src/components/DragAndDrop/index.js